import { render } from "./SubChannelManagement.vue?vue&type=template&id=210d7bdf&scoped=true"
import script from "./SubChannelManagement.vue?vue&type=script&lang=js"
export * from "./SubChannelManagement.vue?vue&type=script&lang=js"

import "./SubChannelManagement.vue?vue&type=style&index=0&id=210d7bdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210d7bdf"]])

export default __exports__